module.exports = __webpack_public_path__ + "img/premium-partner-logo.62d1f5a4.svg";